import { AccessorsMutatorsDecorator, Model } from '../../helpers';
import { TranslatableModel } from './translatable-model';

export class SmsReminder extends TranslatableModel {

    /**
     * @type {string[]}
     */
    static get translatableAttributes() {

        return [];
    }

    static get ACTIVE() {

        return 1;
    }

    static get NOT_ACTIVE() {

        return 0;
    }

    static get TYPE_BEFORE() {

        return 1;
    }

    static get TYPE_AFTER() {

        return 0;
    }

    static get TYPES() {

        return {
            [this.TYPE_BEFORE]: 'BEFORE',
            [this.TYPE_AFTER]: 'AFTER',
        };
    }

    static get FORMATTED_STATUSES() {

        return {
            [this.ACTIVE]: 'ACTIVE',
            [this.NOT_ACTIVE]: 'INACTIVE',
        };
    }

    formatStatus() {

        return this.constructor.FORMATTED_STATUSES[this.status];
    }

    formatTypes() {

        return this.constructor.TYPES[this.type];
    }

    getStatusLabel() {

        switch (this.status) {

            case this.constructor.ACTIVE:

                return 'ACTIVE';

            case this.constructor.NOT_ACTIVE:

                return 'INACTIVE';
        }
    }

}

AccessorsMutatorsDecorator('id', 'type', 'status', 'message', 'message_ar', 'number_days', 'created_at', 'updated_at', 'language', 'name', 'name_ar' )(SmsReminder);



// WEBPACK FOOTER //
// ./src/pms-api/models/sms-reminder.model.js